import type { OptionsObject } from "notistack";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import type { AppDispatch } from "../../store/state/rootStore";

type SnackItem = {
  key: string | number;
  message: string;
  options?: OptionsObject;
  dismissed?: boolean;
};

const Notifier = () => {
  const dispatch = useDispatch<AppDispatch>();

  const notifications: SnackItem[] = useSelector((state: any) => state.snack.notifications || []);
  const isRecording: boolean = useSelector((state: any) => state.dailyCall.isRecording);

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [displayed, setDisplayed] = useState<Array<string | number>>([]);

  useEffect(() => {
    const defaultAnchorOrigin = { vertical: "bottom", horizontal: "left" } as const;
    const recordingAnchorOrigin = { vertical: "top", horizontal: "center" } as const;

    notifications.forEach(({ key, message, options = {}, dismissed = false }) => {
      if (dismissed) {
        closeSnackbar(key);
        return;
      }

      if (displayed.includes(key)) return;

      const anchorOrigin = options.anchorOrigin ?? (isRecording ? recordingAnchorOrigin : defaultAnchorOrigin);

      enqueueSnackbar(message, {
        key,
        ...options,
        anchorOrigin,
        onExited: (_event, myKey) => {
          dispatch({ type: "REMOVE_SNACKBAR", payload: { key: myKey } });
          setDisplayed((d) => d.filter((k) => k !== myKey));
        },
      });

      setDisplayed((d) => [...d, key]);
    });
  }, [notifications, displayed, isRecording, closeSnackbar, enqueueSnackbar, dispatch]);

  return null;
};

export default Notifier;
